import { useAuth } from '../../auth/AuthProvider'
import { useAssistantDock } from '../../domains/assistant/dockState'
import { Pentacle } from '../../design/components'
import { AssistantPanel } from './AssistantPanel'
import styles from './assistant.module.css'

/**
 * The assistant, in the app shell — a launcher that is always there and the panel it opens.
 *
 * **Rendered by `AppShell`, so every screen has it.** The assistant used to be a page hanging
 * off one character's sheet, which meant asking it anything cost a navigation away from
 * whatever prompted the question. As a dock it is reachable mid-scene, mid-sheet, mid-city,
 * and the conversation is the same one in all of them.
 *
 * Nothing renders for a signed-out visitor: every assistant call needs a bearer, and a
 * launcher that can only produce a 401 is worse than no launcher.
 */
export function AssistantDock() {
  const { status } = useAuth()
  const isOpen = useAssistantDock((state) => state.isOpen)
  const toggle = useAssistantDock((state) => state.toggle)
  const close = useAssistantDock((state) => state.close)

  if (status !== 'authenticated') return null

  return (
    <>
      <button
        type="button"
        className={styles.launcher}
        aria-expanded={isOpen}
        aria-haspopup="dialog"
        aria-controls="assistant-panel"
        onClick={toggle}
      >
        <Pentacle size={24} />
        <span className={styles.launcherLabel}>Ask Bob</span>
      </button>

      {/* Unmounted rather than hidden while closed: the transcript is server state, so
          nothing is lost, and an unmounted panel is not holding a stream open behind a
          screen the user has moved on from. */}
      {isOpen && <AssistantPanel onClose={close} />}
    </>
  )
}
